export default __webpack_public_path__ + "static/media/IconDesc_Wood.256.7c5ce2a7.png";